import { render } from "./VsPagination.vue?vue&type=template&id=12ef8438"
import script from "./VsPagination.vue?vue&type=script&lang=js"
export * from "./VsPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__